import { Component, Input, OnInit } from '@angular/core';
import { Petition, NULL_PETITION } from '@ncessor/shared';
import { DateRangePipe } from '../../pipes/date-range.pipe';

@Component({
  selector: 'app-petition-summary',
  templateUrl: './petition-summary.component.html',
  styleUrls: ['./petition-summary.component.scss'],
  imports: [DateRangePipe],
})
export class PetitionSummaryComponent implements OnInit {
  @Input() petition: Petition = NULL_PETITION;

  constructor() {}

  ngOnInit(): void {}
}
